import React, { type FC, type ReactNode } from 'react'
import { useUserVotes } from '../hooks/useUserVotes'
import {
  AuthenticatedUserControllerGetUserVotesParamsOrderByEnum,
  BoxesControllerFindAllParamsOrderDirectionEnum,
} from '../types/generated'
import { ScrollBoxes } from './ScrollBoxes'

export const UserVotesScrollBoxes: FC<{
  titleElement: ReactNode | null
  tabsElement: ReactNode
}> = ({ titleElement, tabsElement }) => {
  const {
    data,
    fetchNextPage,
    isFetching,
    refetch,
    isFetchingNextPage,
    isError,
  } = useUserVotes({
    orderBy: AuthenticatedUserControllerGetUserVotesParamsOrderByEnum.Activity,
    orderDirection: BoxesControllerFindAllParamsOrderDirectionEnum.Desc,
  })

  return (
    <ScrollBoxes
      data={data}
      fetchNextPage={fetchNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      isError={isError}
      refetch={refetch}
      titleElement={titleElement}
      tabsElement={tabsElement}
      filterType="my-votes"
    />
  )
}
